import { openBufferInTab } from "@/utils/download";

import { sendRequest } from "../../clients/axios";

export function downloadDriverInvoice(id: string) {
  return sendRequest<undefined, { data: Iterable<number> }>(
    "get",
    `invoice/downloadPDF/${id}`
  ).then((res) => {
    openBufferInTab(new Uint8Array(res.data.data));
  });
}
